import { render, staticRenderFns } from "./SingleCommentTextArea.vue?vue&type=template&id=ee1993ca&scoped=true&"
import script from "./SingleCommentTextArea.vue?vue&type=script&lang=ts&"
export * from "./SingleCommentTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCommentTextArea.vue?vue&type=style&index=0&id=ee1993ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1993ca",
  null
  
)

export default component.exports